var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetCreatedByIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.009,
    height: 77.186,
    viewBox: "0 0 77.009 77.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13798",
    "data-name": "Group 13798",
    transform: "translate(-4.999 -957.546)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5224",
    "data-name": "Rectangle 5224",
    width: 34.504,
    height: 34.5,
    rx: 17.25,
    transform: "matrix(1, 0.017, -0.017, 1, 6.11, 958.054)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5225",
    "data-name": "Rectangle 5225",
    width: 34.5,
    height: 34.5,
    rx: 3,
    transform: "translate(47.008 958.481)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5227",
    "data-name": "Rectangle 5227",
    width: 34.5,
    height: 34.5,
    rx: 3,
    transform: "translate(5.508 999.731)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5228",
    "data-name": "Rectangle 5228",
    width: 34.5,
    height: 34.5,
    rx: 3,
    transform: "translate(47.008 999.731)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetCreatedByIcon);
export default __webpack_public_path__ + "static/media/setCreatedByIcon.b9cfbd0eb85072ca0bde13c3291bd0d0.svg";
export { ForwardRef as ReactComponent };